import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { Link } from 'react-router-dom'
import LoggedSidebar from 'App/Shell/LoggedSidebar'
import '@loyal_template/password.css'

class SecurityAccess extends Component {
  state = {}

  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Minha senha - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='container-fluid px-0 bg-ui-4'>
          <div className='container pt-0 pb-4 py-md-4'>
            <div className='row'>
              <LoggedSidebar selected={this.props.location.pathname} />
              <div className='col-12 col-md-8 mt-0'>
                <div className='row'>
                  <div className='col-12 border-color-ui-3 bg-white border radius'>
                    <div className='checkout-step row px-1 py-2 border-bottom border-color-ui-3 '>
                      <div className='col mr-auto'>
                        <h1 className='txt-title txt-font-body txt-initial color-title mr-auto' tabIndex='1'>
                        Acesso e segurança
                        </h1>
                      </div>
                    </div>
                    <div className='col-12 border-color-ui-3'>
                      <div className='d-flex mt-2 align-items-center'>
                        <i className='icon icon_message mr-2 color-brand-1' tabIndex='2' />
                        <div className='flex-column'>
                          <span className='txt-left txt-font-body txt-body-sm color-ui-2' tabIndex='3'>E-mail</span><br />
                          <strong className='txt-font-body txt-initial color-title txt-email-flow' tabIndex='4'>{this.props.email.value}</strong>
                        </div>
                        <div className='col btn-flat btn-sm txt-right d-block txt-font-body'>
                          <Link
                            to='/token-change-email'
                            className='color-brand-1-acce-bold'
                            tabIndex='5'
                            title='Vai para tela de alterar Email'
                          >
                            Alterar
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className='row px-0 pb-2 pt-half border-bottom border-color-ui-3' />
                    <div className='col-12 border-color-ui-3'>
                      <div className='d-flex mt-2 align-items-center'>
                        <i className='icon icon_password mr-2 color-brand-1' tabIndex='6' />
                        <div className='flex-column'>
                          <span className='txt-left txt-font-body txt-body-sm color-ui-2' tabIndex='7'>Senha</span><br />
                          <strong className='txt-font-body txt-initial color-title' tabIndex='8'>******</strong>
                        </div>
                        <div className='col btn-flat btn-sm txt-right d-block txt-font-body'>
                          <Link
                            to='/my-account/change-password'
                            className='color-brand-1-acce-bold'
                            title='Vai para tela de alterar senha'
                            tabIndex='9'
                          >
                            Alterar
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className='row px-0 pb-2 pt-half border-color-ui-3' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

SecurityAccess.propTypes = {
  location: PropTypes.object.isRequired,
  email: PropTypes.object
}

export default SecurityAccess



// WEBPACK FOOTER //
// ./src/Participant/SecurityAccess/SecurityAccess.js